import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import './RatingPage.css'

import TrackingPage from '../../components/TrackingPage'

import withLang from '../../withLang'

import { createReservationCheckInRating, setReservationCheckInRatingObservations } from '../../services/Metrics'

function RatingPage(props) {
  const { t } = useTranslation()

  const [isLoading, setIsLoading] = useState(false)
  const [hasRated, setHasRated] = useState(null)
  const [thankYou, setThankYou] = useState(false)
  const [observations, setObservations] = useState('')

  function onFaceClick(id) {
    if (!id || isLoading) { return }
    setIsLoading(true)
    createReservationCheckInRating(id)
      .then(res => {
        setIsLoading(false)
        setHasRated(true)
      })
      .catch(error => {
        setIsLoading(false)
        setHasRated(true)
      })
  }

  function handleSaveObservationsClick() {
    const observationsMapped = observations?.trim()
    if (!observationsMapped || isLoading) { return }
    setIsLoading(true)
    setReservationCheckInRatingObservations(observationsMapped)
      .then(() => {
        setIsLoading(false)
        setThankYou(true)
      })
      .catch(() => {
        setIsLoading(false)
        setThankYou(true)
      })
  }

  return (
    <div>
      <main>
        <div className='light-green-bg'>
          <div className="container rating__title-wrapper">
            <h1 className='rating__title'>{hasRated ? t('ratingObservationsTitle') : t('rating')}</h1>
          </div>
        </div>
        <div>
          {hasRated ?
            thankYou ?
              <div>
                <h2 className="title" style={{ marginTop: '10px' }}><b>{t('ratingThankYou')}</b></h2>
              </div>
              :
              <div className='main-frame'>
                <form>
                  <label htmlFor='observations'>{t('observations')}</label>
                  <textarea
                    value={observations || ''}
                    onChange={e => setObservations(e.target.value)}
                    name='observations'
                    className='form-control text-center'
                  />
                </form>
                <div onClick={handleSaveObservationsClick} className="btn btn-green text-uppercase"><b>{t('saveObservations')}</b></div>
              </div>
            :
            <div className='rating__smiles'>
              <Smile label={t('rating2Label')} handleClick={() => onFaceClick(3)} src={require('../../assets/images/happy.svg')} alt='happy' />
              <Smile label={t('rating1Label')} handleClick={() => onFaceClick(2)} src={require('../../assets/images/neutral.svg')} alt='ok' />
              <Smile label={t('rating0Label')} handleClick={() => onFaceClick(1)} src={require('../../assets/images/sad.svg')} alt='sad' />
            </div>
          }
        </div>
      </main>
    </div>
  )
}

export default withLang(RatingPage)

function Smile({ handleClick, label, src, alt, active }) {
  return (
    <div className={`rating__smiles-face ${active ? 'rating__smiles-face--active' : ''}`}>
      <img onClick={handleClick} className='rating__smiles-face-img' src={src} alt={alt} />
      <h2 onClick={handleClick} className='rating__smiles-label'>{label}</h2>
    </div>
  )
}
